export default __webpack_public_path__ + "static/media/petar_m.c0f3b3ae.jpg";